import { render } from "./ReviewEntryHeader.vue?vue&type=template&id=6d8eeb3d&ts=true"
import script from "./ReviewEntryHeader.vue?vue&type=script&lang=ts"
export * from "./ReviewEntryHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__